import request from '@/utils/request'; // 会议室管理
// 新增

export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/meetingInfo/insert',
    method: 'post',
    data: data
  });
} // 修改

export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/meetingInfo/update',
    method: 'post',
    data: data
  });
} // 查询列表

export function fetchList(data) {
  return request({
    url: '/pmsservice/api/meetingInfo/list',
    method: 'post',
    data: data
  });
}
export function fetchMeetingRoomList(data) {
  return request({
    url: '/pmsservice/api/meetingInfo/list',
    method: 'post',
    data: data
  });
} // 查询详细

export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/meetingInfo/get',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(data) {
  return request({
    url: '/pmsservice/api/meetingInfo/delete',
    method: 'post',
    data: data
  });
} // 申请删除

export function fetchApplyDelete(data) {
  return request({
    url: '/pmsservice/api/meetingManage/delete',
    method: 'post',
    data: data
  });
} // 查询会议室申请列表

export function fetchApplyList(data) {
  return request({
    url: '/pmsservice/api/meetingManage/list',
    method: 'post',
    data: data
  });
} // 查询会议室申请详情

export function fetchApplyDetail(data) {
  return request({
    url: '/pmsservice/api/meetingManage/get',
    method: 'post',
    data: data
  });
} // 开始时间下拉小时（前提：选择了会议室，日期）

export function getStartHour(data) {
  return request({
    url: '/pmsservice/api/meetingManage/getStarTime',
    method: 'post',
    data: data
  });
} // 结束时间下拉小时（前提：选择了会议室，日期，开始小时）

export function getEndHour(data) {
  return request({
    url: '/pmsservice/api/meetingManage/getOverTime',
    method: 'post',
    data: data
  });
} // 会议室申请

export function fetchApplyCreate(data) {
  return request({
    url: '/pmsservice/api/meetingManage/insert',
    method: 'post',
    data: data
  });
} // 上传会议纪要

export function upLoadMediaJY(data) {
  return request({
    url: '/pmsservice/api/meetingManage/downLoadMediaJY',
    method: 'post',
    data: data
  });
} // 参会人员下拉框

export function getMeetUserList(data) {
  return request({
    url: '/pmsservice/api/meetingManage/getMeetUserList',
    method: 'post',
    data: data
  });
}